// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "aside[data-v-1cb9048d] {\n  min-height: 100%;\n}", ""]);
// Exports
module.exports = exports;
